exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search__container {\n  display: flex;\n  justify-content: center;\n}\n\n.custom-select {\n  margin-right: 2vh;\n  padding: 1vh;\n}\n\n.react-datepicker-wrapper {\n  width: inherit !important;\n  margin-right: 2vh;\n}\n\n.react-datepicker__input-container input {\n  padding: 1vh;\n}\n\n", ""]);

// exports
